import { FC, useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useDebounce } from '../../scripts/hooks/useDebounce';
import { InStreamVideoContext } from './instreamVideoContext';

type TExCoRichMediaProps = {
  delayBeforeAssessmentMs: number;
};

type TExCoRichMediaPlacementProps = {
  name: string;
};

const ExCoRichMediaPlacement: FC<TExCoRichMediaPlacementProps> = (props) => {
  useEffect(() => {
    const { ExCoPlayer } = window as any;
    if (ExCoPlayer) {
      const playerApi = ExCoPlayer.connect();
      const isInStream = props.name === 'instream';
      playerApi.init(
        isInStream
          ? {}
          : {
              sticky: {
                mode: 'sticky-only',
                closeButton: true,
                pauseOnClose: true,
                width: 300,
                offset: 20
              }
            }
      );
    }
  }, [props.name]);
  if (props.name === 'outstream') {
    return <div id="1a52ee4b-7ed9-4216-8de0-96524e29a4c3" />;
  } else {
    // the div exists elsewhere if in-stream
    return null;
  }
};

let lastLoggedState: string = '';
export const ExCoRichMedia: FC<TExCoRichMediaProps> = (props) => {
  const location = useLocation();
  const { isInStream } = useContext(InStreamVideoContext);
  const debouncedLocation = useDebounce(location, props.delayBeforeAssessmentMs);

  useEffect(() => {
    return () => {
      // remove all richmedia whenever page changes
      const { ExCoPlayer } = window as any;
      if (ExCoPlayer) {
        const playerApi = ExCoPlayer.connect();
        try {
          playerApi.destroy();
        } catch (err) {
          console.error('EXCO destroy failed', err);
        }
      }
      lastLoggedState = '';
    };
  }, [location]);

  // JR we cannot force instream by path because the div may not be present on page yet
  // so we have to wait until the div is actually there before we consider it instream
  // const strippedPath = stripPathLocale(location.pathname);
  const isForcedInStream = false; // isForcedInStreamPath(strippedPath);

  if (location !== debouncedLocation && !isForcedInStream) {
    // during change from one page to another we want to ensure no rich media shows
    // console.info('[EXCO] [RICHMEDIA] returning NULL (waiting for tag)');
    lastLoggedState = '';
    return null;
  }

  // TODO: do we need to do something to restrict what pages takeovers are allowed on?
  if (isInStream || isForcedInStream) {
    if (lastLoggedState !== 'instream') {
      // console.info(`[EXCO] [RICHMEDIA] returning INSTREAM forced=${isForcedInStream} #vm-av=`, document?.getElementById('vm-av'));
      lastLoggedState = 'instream';
    }
    return <ExCoRichMediaPlacement name="instream" />;
  } else {
    if (lastLoggedState !== 'outstream') {
      // console.info('[EXCO] [RICHMEDIA] returning OUTSTREAM #vm-av=', document?.getElementById('vm-av'));
      lastLoggedState = 'outstream';
    }
    return <ExCoRichMediaPlacement name="outstream" />;
  }
};
